import { addCoreAgentConversationTitles } from '../titles/actions';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getConversations } from '@api';

export const getCoreRecentAgentConversationsSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ (page) => addCoreAgentConversationTitles(page.items) ]
	},
	name: 'coreRecentAgentConversations',
	receive: true,
	request: true,
	requestHandler: getConversations,
	retainDataOnRequest: true
});
